// extracted by css-extract-rspack-plugin
export default {"giftNote":"DonationDrawer_giftNote__vZe3G","donationDrawerFooter":"DonationDrawer_donationDrawerFooter__Kg34R"};